import React from 'react'


const Intro = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0a0c]">
      
      {/* 1. Arrière-plan Incliné Signature - Toujours présent pour la cohérence */}
      <div className='ueber_uns-Intro opacity-40'></div>

      {/* 2. Orbes Lumineux Dynamiques (Effet de profondeur) */}
      <div className="absolute top-[10%] left-[5%] w-72 h-72 bg-primary/30 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-[10%] right-[5%] w-[500px] h-[500px] bg-secondary/20 rounded-full blur-[150px]"></div>

      {/* 3. Contenu Principal */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        
        {/* Badge Futuriste */}
        <div className="inline-flex items-center gap-3 px-6 py-2 border border-white/10 bg-white/5 backdrop-blur-xl rounded-full mb-12 shadow-2xl">
          <span className="flex h-2 w-2 rounded-full bg-cyan-400 shadow-[0_0_10px_#22d3ee]"></span>
          <span className="text-[10px] md:text-xs font-black uppercase tracking-[0.4em] text-white/80">
            Digital Excellence Center
          </span>
        </div>

        {/* Titre Monumental avec Masque de Texte */}
        <div className="space-y-4 mb-12">
          <h1 className="text-4xl md:text-8xl lg:text-[10rem] font-black leading-none tracking-tighter text-white uppercase italic">
            KON<span className="text-transparent bg-clip-text bg-gradient-to-b from-primary to-secondary">TAKT</span>
          </h1>
          <div className="flex justify-center">
            <div className="h-1.5 w-32 md:w-64 bg-gradient-to-r from-transparent via-primary to-transparent rounded-full shadow-[0_0_20px_rgba(147,51,234,0.5)]"></div>
          </div>
        </div>

        {/* Paragraphe Stratégique avec Mise en Valeur */}
        <div className="max-w-4xl mx-auto mb-20 px-4">
          <p className="text-white/70 text-lg md:text-3xl font-light leading-snug">
            Verwandeln Sie Ihre Vision in digitale Realität. Wir setzen Maßstäbe durch 
            <span className="text-white font-bold px-2 underline decoration-primary decoration-4 underline-offset-8">ergebnisorientiertes Webdesign</span> 
            und eine 
            <span className="text-white font-bold px-2 underline decoration-secondary decoration-4 underline-offset-8">nutzerzentrierte Entwicklung</span>. 
          </p>
        </div>

        {/* CTA : Bouton Magnétique */}
        <div className="flex flex-col items-center gap-6">
          <button className="group relative px-10 py-5 bg-white text-secondary font-black uppercase tracking-widest rounded-2xl transition-all duration-500 hover:scale-105 hover:shadow-[0_0_40px_rgba(255,255,255,0.3)] overflow-hidden">
            <span className="relative z-10">Projekt anfragen</span>
            <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute inset-0 bg-white group-hover:hidden"></div>
            {/* <span className="relative z-10 group-hover:text-white transition-colors duration-500"></span> */}
          </button>
          
          <p className="text-white/40 text-xs md:text-sm font-bold tracking-[0.2em] uppercase">
            Optimiert für maximale <strong className='text-primary'>Konversionsoptimierung</strong>
          </p>
        </div>

      </div>

      {/* 4. Éléments Décoratifs Géométriques (Discrets) */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>
      </div>

      {/* Flèche de défilement stylisée */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
         <span className="text-[10px] text-white/30 uppercase tracking-[0.3em]">Scroll</span>
         <div className="w-[1px] h-12 bg-gradient-to-b from-white/50 to-transparent"></div>
      </div>

    </section>
  );
};

export default Intro